import {SDKEventAttrs} from '@mparticle/web-sdk';
import {
  mParticleEventType,
  mParticleLogEvent,
  mParticleLogPageView,
} from '@treatwell/ui';

export const AVAILABLE_SALONS_TRIGGER_CONTEXT = 'availability/available_salon';

export const trackEvent = ({
  eventName,
  eventType,
  eventAttributes,
}: {
  eventName: string;
  eventType?: (typeof mParticleEventType)[keyof typeof mParticleEventType];
  eventAttributes: SDKEventAttrs;
}) => {
  mParticleLogEvent(
    eventName,
    eventType ? eventType : mParticleEventType.Other,
    eventAttributes,
  );
};

export const trackPageViewEvent = ({
  eventName,
  eventAttributes,
}: {
  eventName: string;
  eventAttributes: SDKEventAttrs;
}) => {
  mParticleLogPageView(eventName, eventAttributes);
};
